<template>
  <div class="text-center">
    <img src="img/address/no-address.png" alt="" class="img-center" />
    <p class="no-delivery mt-2">{{ $t("deliveryServiceUnavailable") }}</p>
    <p
      class="no-delivery-p-tag mb-0"
      v-if="defaultAddress && Object.keys(defaultAddress).length"
    >
      {{ $t("pleaseChooseAnotherOne") }}
    </p>
    <div class="mt-4 mb-1 delivery-serv-buttn">
      <button
        @click="() => this.$bvModal.show('bv-add-address')"
        type="button"
        class="btn btn-outline-primary"
      >
        <span class="button-text"></span> {{ $t("addAddress") }}
      </button>
      <button
        v-if="defaultAddress && Object.keys(defaultAddress).length"
        @click="() => this.$bvModal.show('bv-modal-examples')"
        type="button"
        class="btn btn-outline-primary"
      >
        <span class="button-text"></span>{{ $t("chooseAnother") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      defaultAddress: (state) => state.address.defaultAddress,
    }),
  },
};
</script>
<style scoped>
.btn-outline-primary {
  width: 150px;
}
.img-center {
  width: 200px;
}
.no-delivery {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 27px;
  text-transform: capitalize;
  color: #000000;
}
.no-delivery-p-tag {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
}
.delivery-serv-buttn button {
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  width: 140px;
  font-size: 14px;
}
</style>
